import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { ListModule } from 'src/app/shared/list/list.module';
import { CommonFormattingModule, CommonLayoutModule, CommonTranslationModule } from '@sdbn/common';
import { ExportVisitorLogComponent } from './components/export-visitor-log.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ExportVisitorLogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ListModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    CommonLayoutModule,
    ReactiveFormsModule,
    CommonFormattingModule
  ],
  exports: [
    ExportVisitorLogComponent
  ]

})
export class ExportVisitorLogModule { }
